import { useContext, useState } from "react";
import { UserContext } from "../../../context";
import styles from "./product-rate.module.css";
import CustomerRateList from "./customer-rate-list";
import PartnerRateList from "./partner-rate-list";

enum eTABS {
  CUSTOMER = "CUSTOMER",
  PARTNER = "PARTNER",
}

function ProductRateList() {
  const context: any = useContext(UserContext);
  const [activeTab, setActiveTab] = useState<eTABS>(eTABS.CUSTOMER);

  // useEffect(() => {
  //   setActiveReport(
  //     Utils.isUserHasAccess(
  //       context.user?.privilegeList,
  //       ePrivileges.VIEWREPORTLIST
  //     )
  //       ? eREPORT.REPORTLIST
  //       : Utils.isUserHasAccess(
  //             context.user?.privilegeList,
  //             ePrivileges.VIEWSCHEDULELIST
  //           )
  //         ? eREPORT.SCHEDULELIST
  //         : ""
  //   );
  // }, [context?.user]);

  return (
    <div>
      <div className={styles.parentContainer}>
        {/* Check if user has permission to view already downloaded report list */}
        {/* {Utils.isUserHasAccess(
          context.user?.privilegeList,
          ePrivileges.VIEWREPORTLIST
        ) && ( */}
        <div
          className={`${styles.tab} ${
            activeTab === eTABS.CUSTOMER ? styles.activeTab : ""
          }`}
          onClick={() => {
            setActiveTab(eTABS.CUSTOMER);
          }}
        >
          <span
            className={
              activeTab === eTABS.CUSTOMER
                ? styles.activeText
                : styles.inactiveText
            }
          >
            Customer
          </span>
        </div>
        {/* )} */}
        {/* Check if user has permission to view already created schedules list */}
        {/* {Utils.isUserHasAccess(
          context.user?.privilegeList,
          ePrivileges.VIEWSCHEDULELIST
        ) && ( */}
        <div
          className={`${styles.tab} ${
            activeTab === eTABS.PARTNER ? styles.activeTab : ""
          }`}
          onClick={() => {
            setActiveTab(eTABS.PARTNER);
          }}
        >
          <span
            className={
              activeTab === eTABS.PARTNER
                ? styles.activeText
                : styles.inactiveText
            }
          >
            Service Partner
          </span>
        </div>
        {/* )} */}
      </div>
      <div>
        {activeTab === eTABS.CUSTOMER ? (
          <CustomerRateList />
        ) : activeTab === eTABS.PARTNER ? (
          <PartnerRateList />
        ) : null}
      </div>
    </div>
  );
}

export default ProductRateList;
